export const isOptionPopperSeparator = item => 'separator' in item;
//# sourceMappingURL=typeguards.js.map